import React, { useEffect, useState } from 'react';
import { SmartContainer, Stack, Surface } from '../../../styles/Containers';
import logoFull from '../../../assets/logo-full.png'
import { StyledH3, StyledH5, StyledH6, StyledP } from '../../../styles/StyledHTML';
import { useParams } from 'react-router-dom';
import { ResetForm } from '../../../components/Auth/ResetForm';
import { LoginForm } from '../../../components/Auth/LoginForm';
import { FullAuth } from '../../../redux/Auth/auth.selectors';
import { StyledAuthSurface } from '../../../components/Auth/RecoverPage';

import logoLeft from '../../../assets/logo-left-black-green.png';
export const PageOnboardingNewUser = () => {
    const { token } = useParams();
    const [screen, setScreen] = useState('reset');
    const auth = FullAuth();

    useEffect(() => {
        if (auth.success === true) {
            setScreen('login')
        }

    }, [auth?.success])



    return (
        <Stack flex align="center" justify="center" padding={10} direction="column">
            <SmartContainer flex align="center" justify="center">
                <img src={logoLeft} alt="Capture Collab Logo" style={{ maxWidth: '200px', width: '76%', height: 'auto', marginBottom: '1em' }} />
            </SmartContainer>

            {screen === 'reset' && (
                <SmartContainer maxWidth="400px" textAlign="center">
                    <Stack>
                        <SmartContainer>
                            <StyledH6>Welcome!</StyledH6>
                            <StyledP light>You've been invited to join an account. Let's get started by setting up your password.</StyledP>
                        </SmartContainer>
                        <ResetForm token={token} noControls={true} buttonText="Set Password" passwordLabel="Set your password" />
                    </Stack>

                </SmartContainer>
            )}

            {screen === 'login' && (
                <StyledAuthSurface maxWidth="400px" textAlign="center">
                    <Stack>
                        <Surface>
                            <SmartContainer>
                                <StyledH6>Thanks!</StyledH6>
                                <StyledP light>Now that your password is set, let's log in with the email address the invite was sent to.</StyledP>
                            </SmartContainer>
                        </Surface>
                        <LoginForm redirect="/" noControls={true} />


                    </Stack>

                </StyledAuthSurface>
            )}
        </Stack>
    )
}